import { render, staticRenderFns } from "./dropdown-language.vue?vue&type=template&id=72d88bec&"
import script from "./dropdown-language.vue?vue&type=script&lang=js&"
export * from "./dropdown-language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports